import { render, staticRenderFns } from "./OperationsPayroll.vue?vue&type=template&id=2a9e5c7c"
import script from "./OperationsPayroll.vue?vue&type=script&lang=js"
export * from "./OperationsPayroll.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports